/**
 * Provider availability gates.
 *
 * While a flag is off the provider is absent from the integrations surfaces —
 * not shown as a disabled "coming soon" tile. Flip it to `true` once the
 * PRODUCTION credentials are wired and the card becomes connectable.
 *
 * Typed as `boolean` (not the literal `false`) on purpose so the guarded UI
 * stays type-checked while the flag is off.
 */
export const STRIPE_AVAILABLE: boolean = false;
export const PLAID_AVAILABLE: boolean = false;
